import React from 'react';
import { Box } from '@mui/material';
import EnrichedResultsColumn2 from '../components/EnrichedResultsColumn2';

const FeedResults = ({ data }) => {
  if (data === null || data === undefined) {
    return (
      <Box component="pre" sx={{ m: 0, fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        No results yet. Use mbd.show(data) in your code.
      </Box>
    );
  }

  return <EnrichedResultsColumn2 hits={data} />;
};

export default FeedResults;
